"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_ui_1 = require("@pasport/react-ui");
const Alert = ({ data: { message, status, duration }, onClose }) => {
    (0, react_1.useEffect)(() => {
        const interval = setTimeout(() => { onClose(); }, duration ?? 5500);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "card shadow bg-dark text-white p-2 mb-2 ", style: { borderWidth: 2, width: '100vw', maxWidth: 600,
            pointerEvents: 'auto' }, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("a", { onClick: (e) => {
                        e.preventDefault();
                        onClose();
                    }, href: "/", className: "p-2 link-light fs-3 text-decoration-none lh-1", style: { position: 'absolute', right: 0, top: 0 }, children: (0, jsx_runtime_1.jsx)("span", { className: "px-1", children: "\u00D7" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "fw-bold d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)("span", { className: 'fs-2 p-2 lh-1 me-2 bgs-white rounded-circle', children: status === 'error' ? ((0, jsx_runtime_1.jsx)(react_ui_1.ErrorIcon, {})) : ((0, jsx_runtime_1.jsx)(react_ui_1.SuccessIcon, {})) }), (0, jsx_runtime_1.jsx)("span", { children: message })] })] }) }));
};
exports.Alert = Alert;
